import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateInputSize } from '@progress/kendo-angular-dateinputs';
import { CheckBoxRounded } from '@progress/kendo-angular-inputs';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { ContractAPIService } from 'src/app/extensions/services/api/contracts-api.service';
import { isEqual } from 'lodash';

export interface ContractTypesModel extends app.models.DictionaryDataModel {
  isSelected: boolean;
}

@Component({
  selector: 'asset-list-contract',
  templateUrl: './asset-list-contract.component.html',
  styleUrls: ['./asset-list-contract.component.scss'],
  standalone: false,
})
export class AssetListContractComponent implements OnInit {
  public constructor(
    private _activeModal: NgbActiveModal,
    private _contractAPIService: ContractAPIService,
    private _translateService: TranslateService
  ) {}

  public contracts: app.models.ActiveContractModel[] = [];

  public roundedLarge: CheckBoxRounded = 'large';
  public size: DateInputSize = 'large';

  public pageFilter: app.models.GetPagedAssetsPageFilterModel;
  initialFilterState: app.models.GetPagedAssetsPageFilterModel;
  contractTypes: app.models.DictionaryWithCheckbox[];

  public ngOnInit(): void {
    if (this.pageFilter.activeContracts) {
      this._contractAPIService.getActiveContracts().subscribe(x => {
        this.contracts = x;
        this.contracts.forEach(x => (x.isSelected = this.pageFilter.contractIds.includes(x.contractId)));
      });
    } else {
      this._contractAPIService.getInactiveContracts().subscribe(x => {
        this.contracts = x;
        this.contracts.forEach(x => (x.isSelected = this.pageFilter.contractIds.includes(x.contractId)));
      });
    }

    this.contractTypes = [
      {
        name: this._translateService.instant('contracts.contractType.operationalLeasing'),
        isSelected: this.pageFilter.contractTypeCodes.includes(DictionaryContractType.OPERATIONAL_LEASING),
        value: DictionaryContractType.OPERATIONAL_LEASING,
      },
      {
        name: this._translateService.instant('contracts.contractType.financialLeasing'),
        isSelected: this.pageFilter.contractTypeCodes.includes(DictionaryContractType.FINANCIAL_LEASING),
        value: DictionaryContractType.FINANCIAL_LEASING,
      },
      {
        name: this._translateService.instant('contracts.contractType.credit'),
        isSelected: this.pageFilter.contractTypeCodes.includes(DictionaryContractType.CREDIT),
        value: DictionaryContractType.CREDIT,
      },
    ];
  }

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.pageFilter.contractIds = [];
    this.pageFilter.contractTypeCodes = [];

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }

  public applyHandler() {
    this.pageFilter.contractIds = this.contracts.filter(x => x.isSelected).map(x => x.contractId);
    this.pageFilter.contractTypeCodes = this.contractTypes.filter(x => x.isSelected).map(x => x.value);

    this._activeModal.close(
      isEqual(this.pageFilter, this.initialFilterState)
        ? false
        : this.pageFilter.contractIds.length + this.pageFilter.contractTypeCodes.length
    );
  }

  public contractHandler(contractId: string) {
    const contract = this.contracts.find(x => x.contractId == contractId);

    if (contract) {
      contract.isSelected = !contract.isSelected;
    }
  }
}
